<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Notice</h5>
        <p class="component-paragraph">
          Now you can also <strong>explore non-released combinations</strong>.
          Showing these does not make them released. For a formal validation
          please contact your Sales representative using the button on the
          Results page.
        </p>
        <div class="component-button">
          <input
            type="button"
            class="btn btn-secondary"
            value="Continue"
            @click="show = false"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "NonReleasedCombinationsModal",
  data() {
    return {
      show: false
    };
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
